import {
    apiRequest,
    AwardPeriodPrediction
} from "../../../../../services/adapters/kepegawaian/penghargaanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AwardPeriodPrediction, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository